<template lang="pug">
  ul.ods-actions-menu__ul.ods-actions-menu--user__ul
    li.user-ul__user-name
      | Smart cities
      | soporte@smartcities.com
    li.ods-actions-menu__separator
    li
      lang-selector(cssClass="user-ul__languages")
    li.ods-actions-menu__separator
    router-link(
      tag="li"
      to="/profile")
      a
        ods-icon(name="user")
        | {{$t('Profile')}}
    li.ods-actions-menu__separator
    router-link(
      tag="li"
      to="/login")
      a
        ods-icon(name="logout")
        | {{$t('LogOut')}}
</template>

<script>
import LangSelector from '@/components/shared/LangSelector'
export default {
  name: 'UserMenu',
  components: {
    LangSelector
  }
}
</script>

<style lang="scss" scoped>
  .user-ul__languages {
    /deep/ .ods-input__inner {
      border-bottom: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/UserMenu.vue